import PublicShell from "@/components/PublicShell";
import FAQ, { FAQ_TOTAL } from "@/components/FAQ";
import useSeo from "@/hooks/useSeo";

export default function FaqPage() {
  useSeo("FAQ — Savy Kerno", "Answers about Savy Kerno's AI voice agents, CRM, appointments, marketing, pricing, privacy and support — searchable and organised by topic.");
  return (
    <PublicShell eyebrow="Help" title="Frequently asked questions"
      sub={`${FAQ_TOTAL} answers about how Savy Kerno works — including what is live today and what still depends on an external provider or approval.`}
      testid="faq-page">
      <FAQ />
    </PublicShell>
  );
}
